"use client";

import { useEffect } from "react";

const WIDGET_SRC = "https://deskbird.ibos.io/api/chat/widget.js?org=ibos";
const EVENTS = ["pointerdown", "pointermove", "keydown", "touchstart", "scroll"] as const;

// Loads the support chat on the visitor's first interaction instead of on
// page load, keeping its script, cookie and DOM out of the critical path.
export default function ChatWidget() {
  useEffect(() => {
    const load = () => {
      EVENTS.forEach((e) => window.removeEventListener(e, load));
      if (document.querySelector(`script[src="${WIDGET_SRC}"]`)) return;
      const s = document.createElement("script");
      s.src = WIDGET_SRC;
      s.async = true;
      document.body.appendChild(s);
    };
    EVENTS.forEach((e) => window.addEventListener(e, load, { once: true, passive: true }));
    return () => EVENTS.forEach((e) => window.removeEventListener(e, load));
  }, []);

  return null;
}
